// Format date with Thai locale using native JS
export function fDate(dateInput: string | Date): string {
  let date: Date

  if (typeof dateInput === 'string') {
    try {
      date = new Date(dateInput)
    } catch {
      return '-'
    }
  } else {
    date = dateInput
  }

  if (isNaN(date.getTime())) {
    return '-'
  }

  try {
    return date.toLocaleDateString('th-TH', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
  } catch {
    return '-'
  }
}

// Format date with time
export function fDateTime(dateInput: string | Date): string {
  let date: Date

  if (typeof dateInput === 'string') {
    try {
      date = new Date(dateInput)
    } catch {
      return '-'
    }
  } else {
    date = dateInput
  }

  if (isNaN(date.getTime())) {
    return '-'
  }

  try {
    return date.toLocaleString('th-TH', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  } catch {
    return '-'
  }
}

// Format time only
export function fTime(dateInput: string | Date): string {
  let date: Date

  if (typeof dateInput === 'string') {
    try {
      date = new Date(dateInput)
    } catch {
      return '-'
    }
  } else {
    date = dateInput
  }

  if (isNaN(date.getTime())) {
    return '-'
  }

  try {
    return date.toLocaleTimeString('th-TH', {
      hour: '2-digit',
      minute: '2-digit',
    })
  } catch {
    return '-'
  }
}

// Format relative time (e.g., "2 hours ago")
export function fToNow(dateInput: string | Date): string {
  let date: Date

  if (typeof dateInput === 'string') {
    try {
      date = new Date(dateInput)
    } catch {
      return '-'
    }
  } else {
    date = dateInput
  }

  if (isNaN(date.getTime())) {
    return '-'
  }

  const now = new Date()
  const diffInMs = now.getTime() - date.getTime()
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60))
  const diffInHours = Math.floor(diffInMinutes / 60)
  const diffInDays = Math.floor(diffInHours / 24)

  if (diffInMinutes < 1) {
    return 'เมื่อกี้นี้'
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes} นาทีที่แล้ว`
  } else if (diffInHours < 24) {
    return `${diffInHours} ชั่วโมงที่แล้ว`
  } else if (diffInDays < 7) {
    return `${diffInDays} วันที่แล้ว`
  } else {
    return fDate(date)
  }
}

// Check if date is today
export function isToday(dateInput: string | Date): boolean {
  let date: Date

  if (typeof dateInput === 'string') {
    try {
      date = new Date(dateInput)
    } catch {
      return false
    }
  } else {
    date = dateInput
  }

  if (isNaN(date.getTime())) {
    return false
  }

  const today = new Date()
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  )
}
